/**
 * Mode développement : contourne le paiement pour tester téléchargement / aperçu.
 * Activer via REACT_APP_DEV_BYPASS_PAYMENT=true (build-time Create React App).
 * Verrouillé sur NODE_ENV === 'development' : les variables REACT_APP_* sont
 * figées dans le bundle au build, donc sans ce garde il suffirait qu'une
 * variable d'environnement de la plateforme d'hébergement écrase par erreur
 * .env.production pour débloquer les téléchargements payants en prod.
 */
export const DEV_BYPASS_PAYMENT =
    process.env.NODE_ENV === 'development' &&
    (process.env.REACT_APP_DEV_BYPASS_PAYMENT === 'true' ||
        process.env.REACT_APP_DEV_BYPASS_PAYMENT === '1');
